import { useNotificationStore } from '@/stores/helpers/notification.js'
import i18n from '@/i18n/i18n.js'


const { t } = i18n.global

export default function useValidation() {
  // #region - Methods
  const validationStatuses = (validation, enableDirtyClass = true) => {
    return {
      error: validation.$error,
      dirty: enableDirtyClass ? validation.$dirty : false
    }
  }

  const validationErrorNotification = () => {
    const notifications = {
      type: 'danger',
      message: t('shared.validations.error')
    }
    const notificationStore = useNotificationStore()
    notificationStore.add(notifications)
  }
  // endregion

  return { validationStatuses, validationErrorNotification }
}
